/* eslint-disable no-undef, class-methods-use-this, prefer-destructuring, no-param-reassign */

import Forms from "../../lib/forms";

class ContactForm extends Forms {
	init() {
		this.firstForm = document.getElementById("contact-form");
		if (this.firstForm) {
			this.newForm(this.firstForm);

			document.querySelectorAll(".attachment-file").forEach((e) => {
				e.addEventListener("change", (event) => {
					const padre = event.target.parentElement;
					const cadenas = event.target.value.split("\\");

					padre.querySelector(".file-select").innerHTML =
						cadenas[cadenas.length - 1];
				});
			});
		}
	}
}

export default ContactForm;
